import { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { siaranPersMeta, defaultURL } from "../../../data/DataMetatags";
import NextHead from "../../../components/Seo/NextHead";
import { siaranPersBreadcrumb } from "../../../data/DataBreadcrumb";
import { Content } from "../../../components/tentang-perusahaan/general";
import { getSiaranPers } from "src/utils/magnolia";

const SiaranPers = (props) => {
  const { pageTitle, descriptionSEO, asPath, breadcrumb } = props;
  const [pers, setPers] = useState([]);
  const [offset, setOffset] = useState(0)
  
  const getSiaranPersList = async () => {
    const { data, status } = await getSiaranPers({
      params: {
        limit: 12,
        offset: offset,
      }
    })
    if (status === 200) {
      setPers(data);
    }
  };

  useEffect(()=> {
    getSiaranPersList()
  },[offset])

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      ></NextHead>
      <Content
        items={siaranPersBreadcrumb}
        heading="Siaran Pers"
        subSlug="siaran-pers"
        data={pers}
        setOffset={setOffset}
      />
    </Layout>
  );
};
export const getStaticProps = () => {
  const pageTitle = siaranPersMeta.title
  const descriptionSEO = siaranPersMeta.description
  const asPath = "/tentang-perusahaan/siaran-pers"

  const breadcrumb = [
    {
      '@type': 'ListItem',
      position: '1',
      item: {
        '@id': defaultURL,
        name: 'Home'
      }
    },
    {
      '@type': 'ListItem',
      position: '2',
      item: {
        '@id': defaultURL + '/tentang-perusahaan',
        name: 'Tentang Perusahaan'
      }
    },
    {
      '@type': 'ListItem',
      position: '3',
      item: {
        '@id': defaultURL + asPath,
        name: pageTitle
      }
    }
  ]

  return { props:{pageTitle, descriptionSEO, asPath, breadcrumb }}
}

export default SiaranPers;
